module.exports = __webpack_public_path__ + "img/UTPIUT-6.51f23238.jpg";